import React, { Component } from 'react';
import {Button, InputItem, Stepper, List, WingBlank, WhiteSpace} from 'antd-mobile';
import auth from '../../../utils/auth'
// 批次维护
export default class Batch extends Component {
  constructor (props) {
    super(props);
    this.state = {
      mask: false,
      loc3Names: [],
      loc4Names: []
    }
  }
  formatNum = (index) => {
    let str = '';
    if (index < 9) {
      str = '00' + (index + 1)
    } else if (index < 99) {
      str = '0' + (index + 1)
    } else {
      str = index + 1
    }
    return str
  };
  componentWillUnmount() {
    this.setState = () => false
  }
  componentDidMount() {
    if (auth.readCookie('loc')) {
      let loc3Names = auth.readCookie('loc').loc3Names;
      let loc4Names = auth.readCookie('loc').loc4Names;
      this.setState({
        loc3Names,
        loc4Names
      });
    }
  }
  doSave = () => {
    this.props.history.replace('/staff_list/isFirst');
    auth.setCookie('path', '/staff_list/isFirst')
  };
  setData = () => {
    const LOC = auth.readCookie('loc');
    auth.setCookie('loc', {...LOC, ...this.state})
  };
 render() {
   const {loc3Names,loc4Names} = this.state;
   const noData = (loc3Names.length === 0 && loc4Names.length === 0);
   return (
    <React.Fragment>
      {
        noData ? <section className={'text-1'}
            style={{padding: '5px 15px'}}
                 >
          没有<b>保育舍, 配种舍</b>的批次信息, 下一步请点击完成！
          返回添加栋舍,请点击
          <span className={'active'}
              onClick={() => {
                this.props.history.replace('/createfarm/loc_add')
              }}
              style={{fontSize:15}}
          >增加栋舍</span></section>: null
      }
      {/*保育舍 3*/}
      {
        loc3Names.map((o, index) =>(
          <List key={index}
              renderHeader={() => ''}
          >
            <List.Item
                extra={
                <Stepper
                    className={'stepper-round'}
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                    min={0}
                    value={o.batchNum || 0}
                    onChange={v => {
                    let num = parseInt(Number(v));
                    let batchNames = new Array(num).fill(o.name).map((name, batchIndex) => {
                      let currentName = `${this.formatNum(batchIndex)}`;
                      if (o.batchNames[batchIndex]) {
                        currentName = o.batchNames[batchIndex].name
                      }
                      return {
                        name: currentName
                      }
                    });
                    this.setState(state => {
                      o.batchNum = parseInt(Number(v));
                      o.batchNames = batchNames;
                      return state;
                    }, () => {
                      this.setData()
                    })
                  }}
                />}
            >
              <b>{o.name}</b> 批次数量
            </List.Item>
            {
              o.batchNames.map((batch, index) => {
                return <InputItem
                  extra={'批'}
                  maxLength={20}
                    type={'text'}
                    className={'no-border text-right'}
                    key={'loc4' + index}
                    placeholder={batch.name}
                    onChange={v => {
                    this.setState(state => {
                      batch.name = v;
                      return state
                    }, () => {
                      this.setData()
                    })
                  }}
                       >
                  批次名称({`${index + 1}`})
                </InputItem>
              })
            }
          </List>
          )
        )
      }

      {/*育肥舍 4*/}

      {
        loc4Names.map((o, index) =>(
            <List key={index}
                renderHeader={() => ''}
            >
              <List.Item
                  extra={
                  <Stepper
                      className={'stepper-round'}
                      style={{ width: '100%', minWidth: '100px' }}
                      showNumber
                      min={0}
                      value={o.batchNum || 0}
                      onChange={v => {
                      let num = parseInt(Number(v));
                      let batchNames = new Array(num).fill('').map((name, batchIndex) => {
                        let currentName = `${this.formatNum(batchIndex)}`;
                        if (o.batchNames[batchIndex]) {
                          currentName = o.batchNames[batchIndex].name
                        }
                        console.log(batchIndex,currentName);
                        return {
                          name: currentName
                        }
                      });
                      this.setState(state => {
                        o.batchNum = parseInt(Number(v));
                        o.batchNames = batchNames;
                        return state;
                      }, () => {
                        this.setData()
                      })
                    }}
                  />}
              >
                <b>{o.name}</b> 批次数量
              </List.Item>
              {
                o.batchNames.map((batch, index) => {
                  return <InputItem
                      maxLength={20}
                      extra={'批'}
                      type={'text'}
                      className={'no-border text-right'}
                      key={'loc3' + index}
                      placeholder={batch.name}
                      onChange={v => {
                      this.setState(state => {
                        batch.name = v;
                        return state
                      }, () => {
                        this.setData()
                      })
                    }}
                         >
                    批次名称({`${index + 1}`})
                  </InputItem>
                })
              }
            </List>
          )
        )
      }

      <WingBlank size="lg">
        <WhiteSpace size={'lg'} />
        <Button type={'primary'}
            onClick={this.doSave}
        >完成</Button>
      </WingBlank>
    </React.Fragment>
  )
 }
}
